export default __webpack_public_path__ + "static/media/bootcamp_dragon.01c8d4af.png";